module.exports = __webpack_public_path__ + "time.svg?64b168042b46391752ea615fb33d6992";